import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import React from 'react';
import { Link } from 'react-router-dom';
import PageHome from '../components/PageHome';
import { informationOutline } from 'ionicons/icons';

export default class Home extends React.Component {
  render() {
    return (
      <PageHome large title="Grenzwerte.swiss">
        <div className="home-header">
          <div className="home-header__inner">
            <img alt="" src="gw-logo.svg" />
            <Link to="/about" className="home_header__about">
              <img alt="" src="icon-info.svg" />
            </Link>
          </div>
        </div>
        <div className="tiles-container">
          <div className="tiles">
            <Link to="/uebersichtstabellen/schadstoffgrenzwerte" className="tiles__button">
              <span>Grenzwerte</span>
              <img alt="" src="icons/grenzwerte.svg" />
            </Link>
            <Link
              to="/uebersichtstabellen/schadstoffgrenzwerte/neophyten"
              className="tiles__button"
            >
              <span>Neophyten</span>
              <img alt="" src="icons/neophyten.svg" />
            </Link>
            <Link
              to="/uebersichtstabellen/bauschadstoffe"
              className="tiles__button"
            >
              <span>Bauschadstoffe</span>
              <img alt="" src="icons/bauschadstoffe.svg" />
            </Link>
            <Link to="/uebersichtstabellen/lvacodes" className="tiles__button">
              <span>LVA-Codes</span>
              <img alt="" src="icons/lva-codes.svg" />
            </Link>
            <Link to="/rechtlichebestimmungen" className="tiles__button">
              <span>Verordnungen</span>
              <img alt="" src="icons/rechtliche.svg" />
            </Link>
            <Link to="/uebersichtstabellen/dichten" className="tiles__button">
              <span>Dichten</span>
              <img alt="" src="icons/dichten.svg" />
            </Link>
            <Link to="/kbs" className="tiles__button">
              <span>KbS</span>
              <img alt="" src="icons/kbs.svg" />
            </Link>
            {
              localStorage.getItem('unlocked') ? 
              <Link to="/internes" className="tiles__button">
                <span>Internes</span>
                <img alt="" src="icons/internal.svg" />
              </Link> : null
            }
          </div>
        </div>
        <div className="home-footer">
          <img
            alt=""
            onClick={() => {
              window.open('https://friedlipartner.ch/', '_blank');
            }}
            src="FP_Logo.svg"
          />
        </div>
      </PageHome>
    );
  }
}
